import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'telefone' })
export class TelefonePipe implements PipeTransform {
    transform(value) {
        if (value != null && value.length==11) {
        var cell = value.substring(0,0)+'('+value.substring(0,2)+') '+value.substring(2,7)+'-'+value.substring(7);
        return cell;
        } else if (value != null && value.length==10) {
            var cell = '('+value.substring(0,2)+') '+value.substring(2,6)+'-'+value.substring(6);
            return cell;
        } else {
            return value;
        }
    }
}